export default __webpack_public_path__ + "static/0265-118359d341b6da97183dec48f24d95ef.png";